const Efirma = (): JSX.Element => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        opacity="0.2"
        cx="35"
        cy="35"
        r="20.4815"
        transform="rotate(90 35 35)"
        fill="#00DC5A"
      />
      <g opacity="0.5" filter="url(#filter0_b_1001_105730)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.0753 16.5894C30.0725 21.1696 32.1618 26.5062 36.742 28.5091C41.3221 30.5119 46.6587 28.4226 48.6616 23.8424C50.6644 19.2623 48.5751 13.9257 43.995 11.9228C39.4148 9.91996 34.0782 12.0093 32.0753 16.5894ZM40.3823 15.2824C39.9477 16.2763 40.4011 17.4343 41.3949 17.8689C42.3888 18.3035 43.5468 17.8501 43.9814 16.8563C44.416 15.8624 43.9626 14.7044 42.9688 14.2698C41.9749 13.8352 40.8169 14.2886 40.3823 15.2824Z"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_b_1001_105730)">
        <rect
          x="40.7148"
          y="26.9531"
          width="35.1998"
          height="6.03425"
          transform="rotate(113.619 40.7148 26.9531)"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.5" filter="url(#filter2_b_1001_105730)">
        <rect
          x="32.4385"
          y="38.3516"
          width="4.52569"
          height="4.52569"
          transform="rotate(158.619 32.4385 38.3516)"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.5" filter="url(#filter3_b_1001_105730)">
        <rect
          x="30.625"
          y="42.498"
          width="4.52569"
          height="4.52569"
          transform="rotate(158.619 30.625 42.498)"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.5" filter="url(#filter4_b_1001_105730)">
        <rect
          x="28.8115"
          y="46.6445"
          width="4.52569"
          height="4.52569"
          transform="rotate(158.619 28.8115 46.6445)"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.5" filter="url(#filter5_b_1001_105730)">
        <rect
          x="26.998"
          y="50.792"
          width="4.52569"
          height="4.52569"
          transform="rotate(158.619 26.998 50.792)"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.5" filter="url(#filter6_b_1001_105730)">
        <rect
          x="25.1846"
          y="54.9385"
          width="4.52569"
          height="4.52569"
          transform="rotate(158.619 25.1846 54.9385)"
          fill="#00DC5A"
        />
      </g>
      <g opacity="0.6" filter="url(#filter7_b_1001_105730)">
        <path d="M52.2002 49.4336L43.7297 57.9041V40.9631L52.2002 49.4336Z" fill="#00B94B" />
      </g>
      <g opacity="0.6" filter="url(#filter8_b_1001_105730)">
        <path d="M25.7559 21.4336L17.2854 29.9041V12.9631L25.7559 21.4336Z" fill="#00B94B" />
      </g>
      <defs>
        <filter
          id="filter0_b_1001_105730"
          x="26.8145"
          y="6.66211"
          width="27.1074"
          height="27.1074"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_1001_105730"
          x="16.583"
          y="20.0356"
          width="28.6318"
          height="43.6685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_b_1001_105730"
          x="22.0742"
          y="29.6372"
          width="14.8643"
          height="14.8638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_b_1001_105730"
          x="20.2607"
          y="33.7842"
          width="14.8643"
          height="14.8633"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_b_1001_105730"
          x="18.4473"
          y="37.9307"
          width="14.8643"
          height="14.8633"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_b_1001_105730"
          x="16.6338"
          y="42.0781"
          width="14.8643"
          height="14.8633"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_b_1001_105730"
          x="14.8203"
          y="46.2246"
          width="14.8643"
          height="14.8633"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.25" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_b_1001_105730"
          x="39.7295"
          y="36.9629"
          width="16.4707"
          height="24.9414"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_b_1001_105730"
          x="13.2852"
          y="8.96289"
          width="16.4707"
          height="24.9414"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1001_105730"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1001_105730"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Efirma;
